import { render, staticRenderFns } from "./EmployeeNav.vue?vue&type=template&id=af9af1f0"
import script from "./EmployeeNav.vue?vue&type=script&lang=js"
export * from "./EmployeeNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports